import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import store from '@/store';
import { PresetTag } from '@/components/DesignStudio/ImageEffectsProperties/types/presets';
import CBadge from '@/components/shared/CBadge';


export default /*#__PURE__*/_defineComponent({
  __name: 'HeaderTags',
  setup(__props) {

const availableTags = computed(() => store.getters['imageEffectsProperties/availableTags']);
const selectedTags = computed(() => store.getters['imageEffectsProperties/selectedTags']);

const handleToggleTag = (tag: PresetTag) => {
    store.dispatch('imageEffectsProperties/toggleTag', tag);
};

return { __sfc: true,availableTags, selectedTags, handleToggleTag, CBadge }
}

})